import React from 'react';
import { Card } from '../ui/card';
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts';

const corto = (f) => `${f.slice(8, 10)}/${f.slice(5, 7)}`;

export const ActividadChart = ({ serie }) => (
  <Card className="p-5 bg-white border-slate-200 lg:col-span-2" data-testid="act-chart">
    <div className="flex items-baseline justify-between mb-3">
      <h3 className="text-base font-bold text-slate-800" style={{ fontFamily: 'Manrope, sans-serif' }}>Uso por día</h3>
      <p className="text-xs text-slate-400">Usuarios con actividad e ingresos</p>
    </div>
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={serie} margin={{ top: 4, right: 8, left: -18, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" vertical={false} />
          <XAxis dataKey="fecha" tickFormatter={corto} tick={{ fontSize: 11, fill: '#64748b' }} axisLine={false} tickLine={false} minTickGap={16} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#64748b' }} axisLine={false} tickLine={false} />
          <Tooltip labelFormatter={corto} contentStyle={{ borderRadius: 10, border: '1px solid #e2e8f0', fontSize: 12 }} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="usuarios" name="Usuarios activos" fill="#0f766e" radius={[4, 4, 0, 0]} maxBarSize={26} />
          <Line dataKey="logins" name="Ingresos" stroke="#f59e0b" strokeWidth={2} dot={false} type="monotone" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  </Card>
);

export default ActividadChart;
